import { Typography, TypographyProps } from "@mui/material";
import { Moment } from "moment";
import { useEffect, useState } from "react";

interface RelativeTimeTypographyProps extends TypographyProps {
  time?: Moment; // The moment object to display
  intervalSeconds?: number; // Refresh interval in seconds (default: 5)
}

const RelativeTimeTypography: React.FC<RelativeTimeTypographyProps> = ({
  time,
  intervalSeconds = 5,
  children,
  ...props
}) => {
  const [relativeTime, setRelativeTime] = useState<string>(
    time ? time.fromNow() : "Never"
  );

  useEffect(() => {
    if (!time) return;

    const updateRelativeTime = () => {
      setRelativeTime(time.fromNow());
    };

    updateRelativeTime(); // Initial update
    const intervalId = setInterval(updateRelativeTime, intervalSeconds * 1000);

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [time, intervalSeconds]);

  return (
    <Typography variant="caption" {...props}>
      {relativeTime}
    </Typography>
  );
};

export default RelativeTimeTypography;
